import { FC, SVGProps } from 'react';

const Edit: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0336 3.93282C11.4938 3.93282 11.8669 4.30591 11.8669 4.76615C11.8669 5.22639 11.4938 5.59949 11.0336 5.59949H4.65561C4.10943 5.59949 3.66667 6.04225 3.66667 6.58843V19.3444C3.66667 19.8906 4.10943 20.3333 4.65561 20.3333H17.4116C17.9577 20.3333 18.4005 19.8906 18.4005 19.3444V12.9664C18.4005 12.5062 18.7736 12.1331 19.2338 12.1331C19.6941 12.1331 20.0672 12.5062 20.0672 12.9664V19.3444C20.0672 20.811 18.8782 22 17.4116 22H4.65561C3.18896 22 2 20.811 2 19.3444V6.58843C2 5.12178 3.18896 3.93282 4.65561 3.93282H11.0336ZM20.0113 5.54361C20.4407 5.11423 20.4407 4.41807 20.0113 3.9887C19.5819 3.55932 18.8858 3.55932 18.4564 3.9887L9.96378 12.4813L9.44548 14.5545L11.5187 14.0362L20.0113 5.54361ZM21.1898 2.81019C22.2701 3.89044 22.2701 5.64187 21.1898 6.72212L12.534 15.3779C12.4272 15.4847 12.2934 15.5605 12.1468 15.5971L8.50228 16.5083C7.89197 16.6609 7.33914 16.108 7.49172 15.4977L8.40286 11.8532C8.43949 11.7066 8.51526 11.5728 8.62206 11.466L17.2779 2.81019C18.3581 1.72994 20.1096 1.72994 21.1898 2.81019Z"
      fill="currentColor"
    />
  </svg>
);

export default Edit;
